import React from 'react';
import { withTranslation, Trans } from 'react-i18next';

import { withStyles } from '@material-ui/core/styles';
import {
  Dialog, DialogContent, DialogTitle, IconButton,
} from '@material-ui/core';
import Clear from '@material-ui/icons/Clear';

import ReactQuill from 'react-quill';
import CPopup from './CPopup';
import styles from '../../assets/jss/CropImageStyle';
import 'react-quill/dist/quill.snow.css';

class CModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openStepModal: false,
      modalBody: '',
    };
  }

  closeDialogue = () => {
    this.setState({
      openStepModal: false,
    });
  };

  render() {
    const {
      classes,
      increaseWidth,
      templateModel,
      adjustModalSize,
      fromRequestDemo,
      handleClose,
      open,
      onEntered,
      headerIcon,
      title,
      isQuill,
      children,
      className,
      theme,
    } = this.props;

    const { openStepModal, modalBody } = this.state;

    return (
      <div>
        <CPopup
          openDialouge={openStepModal}
          modalDismiss={this.closeDialogue}
          modalContent={modalBody}
        />
        <Dialog
          disableEnforceFocus
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={!!open}
          disableEscapeKeyDown
          disableBackdropClick
          onEntered={onEntered}
          className={`${classes.modalContainer} 
          ${fromRequestDemo ? classes.fromRequestDemo : ''} 
          ${increaseWidth ? classes.historyModal : ''} 
          ${templateModel ? classes.templateModel : ''}
          ${adjustModalSize ? classes.adjustModalSize : ''} 
          ${classes.customModalWidth}`}
        >
          <DialogTitle
            className={`${classes.dialogTitle} ${fromRequestDemo ? classes.fromRequestDemoTitle : null}`}
            id="customized-dialog-title"
          >

            <div className={`${classes.dialogImg} ${classes.dialogImgPlatform}`} />
            {headerIcon}
            <Trans i18nKey={title} />

            <IconButton
              aria-label="Close"
              className={classes.cancelCrossIcon}
              onClick={handleClose}
            >
              <Clear />
            </IconButton>
          </DialogTitle>
          <div className={classes.divImage}>
            {/* <span className={classes.moduleImage}>{this.props.icon ? this.props.icon : this.props.icons}</span> */}
          </div>
          <DialogContent
            className={`${classes.dialogContent} ${classes[fromRequestDemo ? 'fromRequestDemoContent' : '']} ${classes[className || '']}  ${theme.logo ? 'darkTheme' : 'lightTheme'}`}
          >

            {isQuill
              ? (
                <ReactQuill
                  readOnly
                  theme="bubble"
                  value={children}
                />
              )
              : children}

          </DialogContent>
        </Dialog>

      </div>
    );
  }
}

CModal.defaultProps = {
  crossIcon: true,
  adjustModalSize: false,
};
const styleSheet = withStyles(styles, { withTheme: true })(CModal);
export default withTranslation()(styleSheet);
